import { render } from "./CategoryModal.vue?vue&type=template&id=71279f96&ts=true"
import script from "./CategoryModal.vue?vue&type=script&lang=ts"
export * from "./CategoryModal.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/esim/admin-src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__